import { Controller } from '@hotwired/stimulus'

// Narrows the specialization checkboxes that are already on the page.
//
// Nothing here talks to the server: the filter renders the whole list into the HTML, so the
// search is a function of bytes the visitor already has. That is the entire security story —
// no endpoint, no query, no rate limit, because there is no request.
export default class extends Controller {
  static targets = ['input', 'empty']

  connect () {
    // A filter change re-renders this panel; start from an unfiltered list every time.
    this.filter()
  }

  filter () {
    const query = this.hasInputTarget ? this.inputTarget.value.trim().toLowerCase() : ''
    let visible = 0

    for (const option of this.#options()) {
      // includes(), never a RegExp built from the query: `new RegExp('(')` throws — a visitor
      // typing "C++ (senior)" would break their own filter — and a pattern a stranger supplies
      // is the standard way to hand them our CPU.
      const match = query === '' || this.#haystack(option).includes(query)

      option.hidden = !match
      if (match) visible += 1
    }

    if (this.hasEmptyTarget) this.emptyTarget.hidden = query === '' || visible > 0
  }

  // The visible title plus the label's hidden Ukrainian/Russian index, as one string to search.
  // The tags are English and this page is Ukrainian, so "бухгалтер" matched nothing at all until
  // the index existed. A label that carries none searches by its title alone, exactly as before —
  // which is what keeps a location or a company checkbox out of every result.
  #haystack (option) {
    return `${option.textContent} ${option.dataset.synonyms || ''}`.toLowerCase()
  }

  // The checkbox labels Filter::Desktop::Item::Component renders. Read as text and toggled
  // with `hidden` — nothing the visitor types is ever written into the DOM.
  #options () {
    return this.element.querySelectorAll('label.custom-checkbox')
  }
}
